<div class="dropzone" id="file-dropzone">
    <label for="file-input">Drag & Drop files here or click to browse</label>
    <input type="file" id="file-input" multiple>
</div>
<div class="file-list" id="file-list"></div>